import React from 'react';
import PropTypes from 'prop-types';
import FlexContainer from '../FlexContainer/FlexContainer';
import css from './LegendItem.module.scss';

const LegendItem = ({label, color}) => {
  return (
    <FlexContainer className={css.legendItem} alignItems="center" flexWrap="nowrap" gap={10}>
      <div
        className={css.legendColor}
        style={{backgroundColor: color}}
      />
      <span>{label}</span>
    </FlexContainer>
  );
};

LegendItem.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default LegendItem;
